$component-class: 'stats-type-6';
$animation-types: (
  'fade-up': translateY(30px),
  'fade-down': translateY(-30px),
  'fade-left': translateX(30px),
  'fade-right': translateX(-30px),
  'none': none,
);
$animation-easings: (
  'linear': linear,
  'ease': ease,
  'ease-in': ease-in,
  'ease-out': ease-out,
  'ease-in-out': ease-in-out,
);

.#{$component-class} {
  background-color: var(--background-color-primary);

  &__counters {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: var(--spacing-2xl);
  }

  &__counter {
    min-width: 50%;
    display: grid;
    gap: 0;
    grid-template-rows: subgrid;
    grid-row: span 3;
    opacity: 0;
    transition:
      opacity var(--animation-duration, 600ms),
      transform var(--animation-duration, 600ms);

    &.is-visible {
      opacity: 1;
    }
  }
}

.#{$component-class}--dark {
  background-color: var(--background-color-alternate);
}

@each $key, $value in $animation-types {
  .#{$component-class}__counters--#{$key} .#{$component-class}__counter {
    @if $key == 'none' {
      opacity: 1;
      transform: translate(0);
      transition: none;
    } @else {
      transform: $value;

      &.is-visible {
        @if str-index($key, 'fade-up') or str-index($key, 'fade-down') {
          transform: translateY(0);
        } @else if str-index($key, 'fade-left') or str-index($key, 'fade-right') {
          transform: translateX(0);
        }
      }
    }
  }
}

@each $easing, $function in $animation-easings {
  .#{$component-class}__counters--#{$easing} .#{$component-class}__counter {
    transition-timing-function: $function;
  }
}
